import { useEffect, useState } from "react";

const apiUrl =
  process.env.REACT_APP_API_URL || "http://localhost:5001/api";

function getAuthToken() {
  return (
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    ""
  );
}

export default function usePreferredLaunchConfiguration({
  entry,
  selectedLaunchConfigurationId
}) {
  const initialPreferredLaunchConfigurationId =
    entry?.viewerContext?.preferredLaunchConfigurationId || null;
  const [preferredLaunchConfigurationId, setPreferredLaunchConfigurationId] =
    useState(initialPreferredLaunchConfigurationId);
  const [isSaving, setIsSaving] = useState(false);
  const [status, setStatus] = useState({
    kind: "",
    message: ""
  });

  useEffect(() => {
    setPreferredLaunchConfigurationId(
      entry?.viewerContext?.preferredLaunchConfigurationId || null
    );
    setStatus({
      kind: "",
      message: ""
    });
  }, [entry?._id, entry?.viewerContext?.preferredLaunchConfigurationId]);

  const isPreferredSelection =
    Boolean(selectedLaunchConfigurationId) &&
    selectedLaunchConfigurationId === preferredLaunchConfigurationId;

  const canPersistPreference =
    Boolean(entry?.slug && selectedLaunchConfigurationId);

  const persistPreference = async (method) => {
    if (!entry?.slug) {
      return;
    }

    const token = getAuthToken();

    setIsSaving(true);
    setStatus({
      kind: "",
      message: ""
    });

    try {
      const response = await fetch(
        `${apiUrl}/catalog/${entry.slug}/preferred-launch`,
        {
          method,
          headers: {
            "Content-Type": "application/json",
            ...(token
              ? { Authorization: `Bearer ${token}` }
              : {})
          },
          ...(method === "PUT"
            ? {
                body: JSON.stringify({
                  launchConfigurationId:
                    selectedLaunchConfigurationId
                })
              }
            : {})
        }
      );

      const payload = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(
          payload?.error ||
          payload?.message ||
          "Unable to save preferred activity mode."
        );
      }

      setPreferredLaunchConfigurationId(
        payload?.preferredLaunchConfigurationId || null
      );
    } catch (error) {
      setStatus({
        kind: "error",
        message:
          error?.message ||
          "Unable to save preferred activity mode."
      });
    } finally {
      setIsSaving(false);
    }
  };

  return {
    canPersistPreference,
    isPreferredSelection,
    isSaving,
    preferredLaunchConfigurationId,
    setPreferredLaunchConfiguration: () => persistPreference("PUT"),
    clearPreferredLaunchConfiguration: () => persistPreference("DELETE"),
    status
  };
}
